var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 8,
    viewBox: "0 0 50 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    width: 8,
    height: 8,
    rx: 4,
    fill: "#2A364E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    x: 21,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F1BA6A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 27",
    x: 42,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#3AA1ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot3);
export default __webpack_public_path__ + "static/media/dot3.6215552c15974e0f48c15d1a32338766.svg";
export { ForwardRef as ReactComponent };